import React from "react";

import { Table } from "../../../../../../components";
import { useECColumns, useECRequests } from "../../hooks";
import { useHistory } from "react-router-dom";

export const RequestsTable = () => {
  const history = useHistory();
  const { requests } = useECRequests();
  const { columns } = useECColumns();

  return (
    <Table
      columns={columns}
      dataSource={requests}
      rowKey="requestId"
      onRow={() => ({
        onClick: () => history.push("/procedure/employee-confirmation/1"),
      })}
    />
  );
};
